<template>
    <i class="fa-solid fa-bookmark cursor:pointer color:#538BD4" @click="remove" v-if="modelValue"></i>
    <img alt="" class="w:24 h:24 cursor:pointer" @click="add" :src="`${prefix}image/icon_rollback.svg`" v-else-if="rollback" />
    <i class="fa-regular fa-bookmark cursor:pointer color:primary:hover" @click="add" v-else></i>
</template>

<script setup>
    const props = defineProps({
        modelValue: { required: true, type: Boolean },
        post_id: { required: true, type: Number },
        recoverable: { default: false, type: Boolean }
    });

    const prefix = inject("prefix");

    const rollback = ref(props.recoverable && props.modelValue);

    const add = () => {
        api(`api/favorite/${props.recoverable ? 'toggle' : 'add'}`, {
            post_id: props.post_id
        }).done((res) => {
            if (res.success) {
                if (props.recoverable) {
                    rollback.value = true;
                }

                emit("update:modelValue", true);
            }
        });
    };

    const emit = defineEmits(["update:modelValue"]);

    const remove = () => {
        api(`api/favorite/${props.recoverable ? 'toggle' : 'remove'}`, {
            post_id: props.post_id
        }).done((res) => {
            if (res.success) {
                emit("update:modelValue", false);
            }
        });
    };
</script>
